// removed by extract-text-webpack-plugin
module.exports = {"pdpHeartItem":"PdpFavoriteItem-style__pdpHeartItem__2iH82","withCircle":"PdpFavoriteItem-style__withCircle__1NAUq","heartComponentWrapper":"PdpFavoriteItem-style__heartComponentWrapper__2HnXv"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/PdpFavoriteItem-style.scss
// module id = 3055
// module chunks = 4